import { createAPIModule } from 'utility/redux/apiModuleHelpers';
// import { createSelector } from 'reselect';

const getStateSlice = (state) => state.api.storage.block.volume.resize;

const {
	actions,
	reducer,
	sagas,
	selectors: defaultSelectors,
} = createAPIModule({
	getStateSlice,
	actionType: 'STORAGE_BLOCK_VOLUME_RESIZE',
	method: 'POST',
	url: '/storage/block/volume/resize.json',
});

const selectors = {
	...defaultSelectors,
};

export { actions, reducer, sagas, selectors };
